import { finalCtaData } from "../data/mock";
import { ArrowRight, Brain } from "lucide-react";

export const FinalCTASection = () => {
  return (
    <section id="final-cta" data-testid="final-cta-section" className="relative py-28" style={{ background: "#1a1c1b" }}>
      <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />

      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h2 className="font-black uppercase leading-[0.88] mb-4" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3.5rem)", letterSpacing: "-0.02em" }}>
            <span className="text-[#888680]">Your Wealth </span>
            <span className="text-[#d9fb06]">Crosses Borders.</span>
            <br />
            <span className="text-[#888680]">Your Advisor </span>
            <span className="text-[#dfddd6]">Should Too.</span>
          </h2>

          {/* Subheadline */}
          <p className="text-[#888680] text-base leading-relaxed mb-12 max-w-xl mx-auto" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            {finalCtaData.subheadline}
          </p>

          {/* Single full-width CTA */}
          <div className="max-w-xl mx-auto">
            <div className="bg-[#302f2c]/50 border border-[#d9fb06]/15 rounded-sm p-8 text-left flex flex-col gap-5">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <Brain size={16} className="text-[#d9fb06]" />
                  <h3 className="text-[#dfddd6] font-bold text-base uppercase" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                    {finalCtaData.paidSession.title}
                  </h3>
                </div>
                <p className="text-[#d9fb06] text-xs font-semibold mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                  {finalCtaData.paidSession.duration}
                </p>
                <p className="text-[#888680] text-sm leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                  {finalCtaData.paidSession.description}
                </p>
              </div>
              <a
                href={finalCtaData.paidSession.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group w-full inline-flex items-center justify-center gap-2 bg-[#d9fb06] text-[#1a1c1b] font-semibold text-sm px-6 py-3.5 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 active:scale-[0.98] uppercase tracking-tight"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {finalCtaData.paidSession.ctaText}
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </a>
            </div>
          </div>

          {/* Subtext */}
          <p className="mt-8 text-[#888680]/50 text-xs italic" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            "{finalCtaData.subtext}"
          </p>
        </div>
      </div>
    </section>
  );
};
